import React, { useCallback } from 'react';
import {
  Avatar,
  ListItem,
  ListItemIcon,
  ListItemText,
  Theme,
  useTheme,
} from '@mui/material';
import { Box } from '@mui/system';
import { ColorPalette, TypographyFamily } from '../../styles/constants';
import { useMsal } from '@azure/msal-react';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import { persistor } from '../../store';

const makeStyles = (theme: Theme) => ({
  listItem: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    p: 0,
    mb: 1,
    cursor: 'pointer',
  },
  listItemContent: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 1.5,
    width: 70,
    height: 80,
    p: 1,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'row',
      alignItems: 'center',
      width: 150,
      height: 75,
    },
  },
  avatar: {
    width: 44,
    height: 44,
    backgroundColor: ColorPalette.COLUMBIA_BLUE,
    color: ColorPalette.DARK_GRAY,
    [theme.breakpoints.down('sm')]: {
      mr: 3,
    },
  },

  listItemIconCircle: {
    justifyContent: 'center',
  },
  listItemText: {
    fontFamily: TypographyFamily.NEXA,
    fontWeight: 700,
    textAlign: 'center',
    mt: 0.8,
    fontSize: 12,
    [theme.breakpoints.down('sm')]: {
      textAlign: 'left',
    },
    color: ColorPalette.WHITE,
  },
});

export function LogoutButton(): JSX.Element {
  const theme = useTheme();
  const style = makeStyles(theme);
  const { instance } = useMsal();

  const logout = useCallback(() => {
    persistor.purge().then(() => {
      instance.logoutRedirect();
    });
  }, [instance]);

  return (
    <ListItem sx={style.listItem} onClick={logout}>
      <Box sx={style.listItemContent}>
        <ListItemIcon sx={style.listItemIconCircle}>
          <Avatar sx={style.avatar}>
            <LogoutRoundedIcon />
          </Avatar>
        </ListItemIcon>
        <ListItemText
          primary="Logout"
          sx={style.listItemText}
          disableTypography
        />
      </Box>
    </ListItem>
  );
}
